import React from 'react'
import ProjectCard from '../components/projects-card/ProjectCard'
import quizzapp from '../assets/projects/quizzapp.jpg'
import youtube from '../assets/projects/youtube.jpg'
import jobTracker from '../assets/projects/job-tracker.jpg'
import instagram from '../assets/projects/instagram.jpg'
import emailscheduler from '../assets/projects/emailscheduler.jpg'
import RButton from '../components/resume-button/RButton'
import link from '../assets/icons/link.png'

const projects = [
    {
        title: 'Email Scheduler',
        des: 'This is an email scheduler made using MERN stack, with OAuth',
        link: "https://github.com/Saicharan0662/email-scheduler-client",
        img: emailscheduler,
    },
    {
        title: 'Job Tracker',
        des: 'A job tracking website made using MERN stack, with auth and CRUD.',
        link: "https://github.com/Saicharan0662/job-tracker-mern",
        img: jobTracker,
    },
    {
        title: 'Minimal youtube clone',
        des: 'A minimal youtube clone made using youtube API and react.',
        link: "https://github.com/Saicharan0662/minimal-youtube-clone",
        img: youtube,
    },
    {
        title: 'Quiz App',
        des: 'A quiz app made using react, uses to create and take up the quiz.',
        link: "https://github.com/Saicharan0662/QuizzApp",
        img: quizzapp,
    },
    {
        title: 'Instagram app clone',
        des: 'An instagram clone made using react and with context API and reducers.',
        link: "https://github.com/Saicharan0662/instagram-app-clone",
        img: instagram,
    },
]

const Projects = () => {
    return (
        <div className='bg-gray-800 md:py-20 projectHeight' id='projects'>
            <div className="pt-8 lg:pt-0 text-center text-white subheadings-font text-4xl font-bold">
                Projects
            </div>
            <div className="flex justify-around align-center flex-wrap w-full mt-5 bg-gray-800">
                {projects.map((project) => {
                    return (
                        <ProjectCard
                            img={project.img}
                            title={project.title}
                            des={project.des}
                            link={project.link}
                        />
                    )
                })}
            </div>
            <div className="py-5 w-full flex flex-col justify-center items-center bg-gray-800">
                <RButton
                    buttonText="Other projects"
                    style={{ width: '160px' }}
                    icon={link}
                    onClick={() => {
                        window.open('https://github.com/Saicharan0662', '_blank')
                    }}
                />
            </div>
        </div>
    )
}

export default Projects
